interface Store {
  currentComponent: string;
  locations: any[];
  selectedLocation: any[];
  currentListComponent: string;
  customerData: any;
  currentAdminComponent: string;
  currentAdminComponentEditCustomer: any;
  apiUrl: string;
}

export const store: Store = {
  currentComponent: "loading",
  locations: [],
  selectedLocation: [],
  currentListComponent: "controlBook",
  customerData: {},
  currentAdminComponent: "users-list",
  currentAdminComponentEditCustomer: {},
  apiUrl: "https://clients.ekos.bz.it",
};
